import { Component, OnInit, Input } from '@angular/core';
import { ParamsService } from 'elbuild-ui-lib-core';
import { Router, ActivatedRoute } from '@angular/router';
import { ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-objective-list-filters',
	templateUrl: './objective-list-filters.component.html',
	styleUrls: ['./objective-list-filters.component.scss']
})
export class ObjectiveListFiltersComponent extends ListFiltersComponent implements OnInit {

	keyword: string;
	active: boolean = true;

	@Input()
	projectid: number;

	submitted = false;

	start: { from: Date, to: Date };
	stop: { from: Date, to: Date };


	constructor(router: Router,
		_route: ActivatedRoute,
		paramsService: ParamsService) {
		super(router, _route, paramsService);

		this.initValues();

	}

	ngOnInit() {
	}

	initValues(): void {
		this.start = { from: undefined, to: undefined };
		this.stop = { from: undefined, to: undefined };
	}

	readQueryParams(params: string) {
		super.readQueryParams(params);
	}

	resetSearch() {
		this.keyword = undefined;
		this.active = true;
		this.submitted = false;
		this.initValues();
		super.resetSearch();
	}

	search(keeppage?: boolean) {
		this.submitted = true;
		if (this.startfrominvalid || this.starttoinvalid || this.stopfrominvalid || this.stoptoinvalid) {
			return;
		}

		this.setValues();
		super.search(keeppage);
	}

	setValues(): void {
		if (this.start.from) {
			this.searchparams.addRangeFilter('startdate', this.start.from.getTime() / 1000, this.start.to.getTime() / 1000);
		} else {
			this.searchparams.removeRangeFilter('startdate');
		}

		if (this.stop.from) {
			this.searchparams.addRangeFilter('stopdate', this.stop.from.getTime() / 1000, this.stop.to.getTime() / 1000);
		} else {
			this.searchparams.removeRangeFilter('stopdate');
		}
	}


	get startfrominvalid(): boolean {
		return this.start.to && !this.start.from;
	}

	set startfrominvalid(v: boolean) {

	}

	get starttoinvalid(): boolean {
		return this.start.from && !this.start.to;
	}

	set starttoinvalid(v: boolean) {

	}

	get stopfrominvalid(): boolean {
		return this.stop.to && !this.stop.from;
	}


	set stopfrominvalid(v: boolean) {

	}
	get stoptoinvalid(): boolean {
		return this.stop.from && !this.stop.to;
	}

	set stoptoinvalid(v: boolean) {

	}

}
